var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9424 7.5C14.9424 11.4277 11.6888 14.625 7.65868 14.625C3.62858 14.625 0.375 11.4277 0.375 7.5C0.375 3.57233 3.62858 0.375 7.65868 0.375C11.6888 0.375 14.9424 3.57233 14.9424 7.5Z",
    fill: "white",
    stroke: "#19B3B5",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 8.69391V9.95139H6.12649L10.0016 6.24293L8.6876 4.98377L4.8125 8.69391ZM11.0176 5.26951C11.0824 5.20649 11.1188 5.1216 11.1188 5.03317C11.1188 4.94473 11.0824 4.85984 11.0176 4.79683L10.1963 4.0109C10.1305 3.94884 10.0418 3.91406 9.94938 3.91406C9.85697 3.91406 9.76826 3.94884 9.70242 4.0109L9.06244 4.62673L10.3764 5.88197L11.0176 5.26951Z",
    fill: "#29BCC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.43a558078cd712f382bb542ddc0a74ad.svg";
export { ForwardRef as ReactComponent };